// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__OQ-MU","richtext":"NotFound_richtext__IBoHK"};